import React from 'react';
import { Container } from './ui/Container';
import { ClockIcon, BrainCircuitIcon, BatteryWarningIcon } from 'lucide-react';
export function ProblemSection() {
  return <section id="problem" className="py-20 bg-slate-900 border-t border-slate-800" data-id="element-113">
      <Container data-id="element-114">
        <div className="max-w-3xl mx-auto" data-id="element-115">
          <div className="text-center mb-16" data-id="element-116">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-117">
              Te duermes… y de pronto abres los ojos.
            </h2>
            <p className="text-xl text-slate-300 leading-relaxed" data-id="element-118">
              No sabes qué hora es (y mejor ni la mires). Solo sabes esto:{' '}
              <span className="text-indigo-300 font-semibold" data-id="element-119">
                tu mente se encendió.
              </span>
            </p>
          </div>

          <div className="bg-slate-950 p-8 md:p-10 rounded-2xl border border-slate-800 shadow-xl mb-12" data-id="element-120">
            <p className="text-lg text-slate-300 mb-6 italic border-l-4 border-indigo-500 pl-4" data-id="element-121">
              "Si me duermo ya, duermo tanto… si no, mañana me arrastro…"
            </p>
            <p className="text-slate-400" data-id="element-122">
              Y ahí se fue la noche. A las 3AM no estás buscando "consejos".
              Estás buscando una salida. Porque cuando te despiertas a esa hora,
              el problema no es solo el sueño. Es el golpe emocional.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-123">
            <div className="text-center p-6 rounded-xl bg-slate-800/30" data-id="element-124">
              <div className="w-12 h-12 bg-slate-800 rounded-full flex items-center justify-center mx-auto mb-4 text-indigo-400" data-id="element-125">
                <ClockIcon className="w-6 h-6" data-id="element-126" />
              </div>
              <h3 className="text-white font-semibold mb-2" data-id="element-127">"Otra vez"</h3>
              <p className="text-slate-400 text-sm" data-id="element-128">
                La frustración de repetir el ciclo noche tras noche.
              </p>
            </div>
            <div className="text-center p-6 rounded-xl bg-slate-800/30" data-id="element-129">
              <div className="w-12 h-12 bg-slate-800 rounded-full flex items-center justify-center mx-auto mb-4 text-indigo-400" data-id="element-130">
                <BrainCircuitIcon className="w-6 h-6" data-id="element-131" />
              </div>
              <h3 className="text-white font-semibold mb-2" data-id="element-132">Mente activa</h3>
              <p className="text-slate-400 text-sm" data-id="element-133">
                Mientras más intentas dormir, más despierta estás.
              </p>
            </div>
            <div className="text-center p-6 rounded-xl bg-slate-800/30" data-id="element-134">
              <div className="w-12 h-12 bg-slate-800 rounded-full flex items-center justify-center mx-auto mb-4 text-indigo-400" data-id="element-135">
                <BatteryWarningIcon className="w-6 h-6" data-id="element-136" />
              </div>
              <h3 className="text-white font-semibold mb-2" data-id="element-137">"Ya perdí"</h3>
              <p className="text-slate-400 text-sm" data-id="element-138">
                La ansiedad de saber que mañana estarás agotada.
              </p>
            </div>
          </div>

          <div className="space-y-6 text-slate-300" data-id="element-139">
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-140">
              La trampa secreta: improvisar
            </h3>
            <p data-id="element-141">
              La mayoría de las mujeres hacen lo mismo: miran la hora, negocian
              con su mente, agarran el teléfono "solo un momento", prueban un
              tip, luego otro…
            </p>
            <p data-id="element-142">
              Y sin darse cuenta, convierten un despertar normal en una hora
              despierta. No porque sean "débiles".{' '}
              <strong className="text-white" data-id="element-143">Porque no tenían un guion.</strong>
            </p>
          </div>
        </div>
      </Container>
    </section>;
}